import { resolveDestination } from "routing/to";
import { useTranslation } from "react-i18next";
import { useAuthState } from "../../../../hooks";
import { NavigationBarLinkStyles } from "../NavigationBarButton.styles";
import { NavigationButtonWithoutSubroutesProps } from "../../../../types";

export const NavigationBarButtonWithoutSubroutes = ({
  translationKey,
  path,
  onClick,
  shopId,
  requiredPermission
}: NavigationButtonWithoutSubroutesProps) => {
  const { t } = useTranslation();

  const { checkPermission } = useAuthState();

  const to = resolveDestination(path.path, shopId);
  if (to === undefined) return null;

  if (requiredPermission && !checkPermission(requiredPermission)) {
    return null;
  }

  return (
    <NavigationBarLinkStyles to={to} onClick={onClick}>
      {t(translationKey)}
    </NavigationBarLinkStyles>
  );
};
